module.exports = {"530423001":"秀山街道","530423002":"九龙街道","530423101":"杨广镇","530423102":"河西镇","530423103":"四街镇","530423104":"纳古镇","530423201":"里山彝族乡","530423202":"高大傣族彝族乡","530423203":"兴蒙蒙古族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530423.json
// module id = 2568
// module chunks = 0